import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { storeActive } from 'ggApp/modules/store';

import SubCategoryList from './SubCategoryList';

const enhance = compose(
    branch(({ subCategories }) => !subCategories, renderNothing),
    connect(
        createStructuredSelector({
            storeActive,
        }),
    ),
);

export default enhance(SubCategoryList);
